// @ts-nocheck
import React, { useEffect } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { Link } from 'react-router-dom';
import MyBookmarkTable from './bookmark-table';
import { TBookmarkPageProps } from '.';

const futureDateRaw = '01-01-2099';
const futureDateTime = new Date(futureDateRaw).getTime();

const StyledLink = styled(Link)`
  font-weight: 600;
`;

export default function MyBookmarkPage(props: TBookmarkPageProps) {
  const { getBookmarks, bookmarks, searchInputValue } = props;

  const [data, setData] = React.useState(bookmarks);

  useEffect(() => {
    getBookmarks();
    setData(bookmarks);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    setData(bookmarks);
  }, [bookmarks]);

  useEffect(() => {
    const filteredBookmarks = bookmarks.filter(bookmark => {
      return bookmark.name.includes(searchInputValue);
    });
    setData(filteredBookmarks);
  }, [searchInputValue, bookmarks]);

  function renderStyledLinkComponent(link: string, name: string) {
    return <StyledLink to={link}>{name}</StyledLink>;
  }

  function constructColumns(): string[] {
    return [
      {
        accessor: (d: { name: string }) => (d.name ? d.name.toLowerCase() : ''),
        Header: 'Bookmark Name',
        Cell: ({ row }: { original: { name: string; link: string } }) => {
          const { name, link } = row.original;
          return renderStyledLinkComponent(link, name);
        },
      },
      {
        accessor: (d: { module: string }) => (d.module ? d.module.toLowerCase() : ''),
        Header: 'Module',
        Cell: ({ row }: { original: { name: string; link: string } }) => row.original.module,
      },
      {
        id: 'createdOn',
        accessor: ({ createdAt }: Date) => new Date(createdAt || futureDateRaw),
        Header: 'Created On',
        sortType: 'datetime',
        Cell: ({ cell }: Date) => {
          const { value } = cell;
          return value.getTime() === futureDateTime ? null : moment(value).format('MM/DD/YYYY');
        },
      },
    ];
  }

  return <MyBookmarkTable columns={constructColumns()} data={data} {...props} />;
}
